import type { Common } from '@libs/domain';

export class OperationControl implements Pick<Common['schema'], 'isStarted'> {
  private constructor(readonly isStarted: boolean) {}
  static init() {
    return new OperationControl(false);
  }

  static fromRaw(raw: OperationControlRaw) {
    return new OperationControl(raw.isStarted);
  }
}

export class OperationControlRaw implements Pick<Common['record'], 'isStarted'> {
  private constructor(readonly isStarted: boolean) {}

  static fromModel(model: OperationControl) {
    return new OperationControlRaw(model.isStarted);
  }
}
